// extracted by mini-css-extract-plugin
module.exports = {"otpInput":"OTPInput_otpInput__33Zec","otpInputHasValue":"OTPInput_otpInputHasValue__3Hsq5","otpInputError":"OTPInput_otpInputError__33Fmx"};